var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSugar = function SvgIconSugar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sugar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.193 14.04a.81.81 0 0 1 .797.17l6.738 6.096c.22.198.316.5.253.791l-1.925 8.909a.82.82 0 0 1-.587.622l-8.664 2.344a.81.81 0 0 1-.786-.21l-3.73-3.718a.83.83 0 0 1-.008-1.168.813.813 0 0 1 1.158-.007l3.396 3.384 7.728-2.091 1.718-7.947-6.033-5.457-7.82 2.539-.832 2.569a.817.817 0 0 1-1.032.528.83.83 0 0 1-.523-1.042l.962-2.97a.82.82 0 0 1 .527-.53z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.308 22.021c.479.104.779.557.67 1.013l-2.222 9.307c-.11.456-.585.741-1.064.638-.479-.104-.779-.557-.67-1.013l2.222-9.307c.11-.456.585-.741 1.064-.638",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.195 17.29a.824.824 0 0 1 1.161-.095l5.983 5.073 5.62-1.533a.823.823 0 1 1 .434 1.589l-6.04 1.647a.82.82 0 0 1-.748-.166l-6.314-5.353a.824.824 0 0 1-.096-1.161M12.678 18.233a.84.84 0 0 1 .812-.2l6.964 1.988c.288.082.51.31.585.6l1.935 7.556a.84.84 0 0 1-.26.84l-5.416 4.773a.84.84 0 0 1-.788.178l-6.964-1.989a.84.84 0 0 1-.582-.59l-1.935-7.158a.84.84 0 0 1 .232-.829zm.813 1.551-4.705 4.491 1.68 6.216 6.064 1.73 4.684-4.126-1.687-6.587z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.749 22.244a.817.817 0 0 1 0 1.179l-3.428 3.333a.87.87 0 0 1-.836.214l-6.857-1.852a.83.83 0 0 1-.597-1.026.86.86 0 0 1 1.056-.58l6.375 1.722 3.075-2.99a.874.874 0 0 1 1.212 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.568 26.024c.402-.107.81.153.91.582l1.5 6.4c.1.428-.144.863-.546.97s-.81-.154-.91-.582l-1.5-6.4c-.1-.428.144-.863.546-.97",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sugar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconSugar;